import React, { useState } from "react";
import WeekSelector from "../../../components/WeekSelector";
import { useSiteContext } from "../../../SiteContext";
import PaycorManager from "../../../managers/PaycorManager";
import "./PaycorDownload.css";
import PageWrapper from "../../../components/PageWrapper";
import Colors from '../../../styles/Colors.json';

interface PaycorDownloadProps {
  setError: (error: string | null) => void;
}

const PaycorDownload: React.FC<PaycorDownloadProps> = ({ setError }) => {
  const { setLoading, year, startDate, endDate, week, createPopup, translator } = useSiteContext();

  const handleDownloadClick = async () => {
    createPopup('Download Initiated', `Getting Paycor Files for week ${week}, ${year}.`)
    setLoading(true);
    // Assuming you're calling this method to download files
    const { file1URL, file2URL } = await PaycorManager.downloadPaycorFiles(startDate, endDate);
    // Now, call createPopup with the URLs
    createPopup("Download Links:", `Payroll File: ${file1URL}\nSupervisor File: ${file2URL}`);
    setLoading(false);
  };

  

  return (
    <PageWrapper title={translator.translate("paycorDownload")} backgroundColor={Colors.White} weekSelector={true}>
      <div className="downloadable-data">
        <button className="download-btn" onClick={handleDownloadClick}>
        {translator.translate("DownloadPaycorForWeek")} {week} / {year}
        </button>
      </div>
    </PageWrapper>
  );
};

export default PaycorDownload;
